import { clsx } from 'clsx';
import { ChangeEvent, FocusEvent, MouseEvent } from 'react';
/* eslint-disable-next-line */
export type textareaSize = 'sm' | 'md' | 'lg';
export interface TextareaProps {
    id: string;
    name: string;
    value?: string;
    placeholder?: string;
    error?: boolean;
    completed?: boolean;
    disabled?: boolean;
    onClick?(event: MouseEvent): void;
    onChange?(event: ChangeEvent): void;
    onBlur?(event: FocusEvent): void;
    onFocus?(event: FocusEvent): void;
    rounded: 'standard' | 'full';
    className?: string;
    required?: boolean;
    size?: textareaSize;
}

export function Textarea(props: TextareaProps) {
    const paddingBase = {
        sm: 'p-1',
        md: 'p-sm',
        lg: 'p-3',
    };
    const classes = clsx(
        'w-full outline-none border text-sm placeholder-gray-300 resize-y',
        props.completed ? 'text-black' : 'text-stone-500',
        paddingBase[props.size || 'md'],
        props.rounded === 'standard' ? 'rounded-md' : 'rounded-full',
        !props.error && 'border-gray-50 hover:border-zinc-500 active:border-zinc-500 focus:border-primary-500',
        props.error && 'border-error-200 hover:border-error-200 active:border-error-200 focus:border-error-200',
        props.disabled && 'border-gray-50 hover:border-gray-50 active:border-gray-50 focus:border-gray-50 bg-gray-50',
        props.className,
    );

    return (
        <textarea
            id={props.id}
            name={props.name}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.onChange}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            onClick={props.onClick}
            disabled={props.disabled}
            className={classes}
            required={props.required || false}
        />
    );
}

Textarea.defaultProps = {
    error: false,
    disabled: false,
    rounded: 'standard',
};

export default Textarea;
